import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { PROCNOTIF_INIT_LOADING, PROCNOTIF_INIT_SUCCESS, PROCNOTIF_INIT_FAIL } from '@/store/types'
export const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {

}

const mutations = {
  [PROCNOTIF_INIT_LOADING](state, err) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [PROCNOTIF_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data.menu
    state.initErr = []
  },
  [PROCNOTIF_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async procNotifManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.procNotifManagement
    commit(PROCNOTIF_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(PROCNOTIF_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(PROCNOTIF_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
